<div style="padding: 1rem">
  <h3>Messprotokoll hochladen</h3>

  <pw-file-input multiple="false" (filesChanged)="onFilesChanged($event)"></pw-file-input>

  <div class="ps-grid-2-col">
    <button [disabled]="!(selectedFiles?.length > 0)" mat-button color="primary" (click)="save()">
      SPEICHERN
    </button>
    <button mat-button color="primary" (click)="dismiss()">
      ABBRECHEN
    </button>
  </div>
</div>
